<template>
  <b-modal
    id="ins-conf-modal"
    ref="ins-conf-modal"
    hide-footer
    no-close-on-backdrop
    hide-header-close
    no-close-on-esc
    title="Travel Insurance"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <!-- As we are no longer authroised to sell Ireland insurance the copy for it has been removed 14/10/2026 -->
      <p v-if="getTerritory() === 'UK'" class="my-4">
        Please tick the box to confirm that you have read and understood the
        <a
          :href="'/travel-insurance/ukipid' + insuranceYear + 'v3.pdf'"
          target="_blank"
        ><strong>Insurance Product Information Document </strong></a>
        and 
        <a 
          :href="'/travel-insurance/ukpolicy2026v3.pdf'" 
          target="_blank"
        ><strong>Policy Document</strong></a> on behalf of all insured persons, as 
        the policy contains details of the 21 day cooling off period, our regulatory 
        status, how to make a claim and the Insurer's complaints procedure. This 
        insurance is being sold to you on a non-advised basis from a single insurer. 
        Cover is only available to individuals who have their primary residence in the 
        United Kingdom, Channel Islands or Isle of Man. Certain sporting and hazardous 
        activities may not be covered, full details may be found in the policy document.
        <br>
        <br>
        Please note cover may be excluded for certain defined pre-existing medical conditions 
        of persons not only booked to travel but also upon whom your travel depends. You should 
        refer any medical condition to the insurer's Medical Screening Service who will confirm 
        if additional cover can be provided and whether any optional additional premiums are 
        payable. If the Medical Screening Service are not able to offer cover, or if you do not 
        wish to pay any addition premium, then they will direct you to alternative policies including the
        <a
          href="https://www.moneyhelper.org.uk/en/everyday-money/insurance/travel-insurance-directory"
          target="_blank"
        ><strong>Money Helper Directory</strong></a> 
        that may be able to do so, and the cost of your Travel Insurance policy will be refunded. 
        <a
          href="https://policyscreening.com/trailfinders/"
          target="_blank"
          class="impact underline"
        ><strong>click here</strong></a>
        for the secure online medical screening service or call 01702 427237. All communication is 
        dealt with in the strictest confidence.
        <br>
        <br>
        Please note there is no cover for the entire duration of your trip if you commence travel contrary to any UK government or FCDO Advice.
      </p>

      <b-form-checkbox
        id="insurance-checkbox-modal"
        v-model="checkboxInsConfirm"
        name="insurance-checkbox-modal"
        value="true"
        unchecked-value="false"
        size="lg"
        class="d-flex justify-content-center mt-5 mb-3 confirm-check"
      >
        I confirm
      </b-form-checkbox>
      <div class="d-flex justify-content-center">
        <b-button
          class="mt-3"
          @click="closeModal"
        >
          Cancel
        </b-button>
        <b-button
          class="mt-3"
          variant="primary"
          :disabled="checkboxInsConfirm === 'false'"
          @click="handleOkInsuranceModal"
        >
          OK
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      checkboxInsConfirm: 'false'
    }
  },
  computed: {
    ...mapGetters({
      receipts: "account/getReceipts",
      summary: "account/getSummary",
      officeOpen: "account/getOfficeInfo",
      accountInfo: "booking/getAccount",
      booking: "booking/getBooking",
      bookingNo: "booking/getBookingNumber",
      bookingInfo: "booking/getBookingInfo",
      userData: "auth/getUserData"
    }),
    insuranceYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    showModal() {
      this.$refs["ins-conf-modal"].show();
    },
    handleOkInsuranceModal() {
      this.$emit("emitedInsConfirmation", this.checkboxInsConfirm);
      this.$refs["ins-conf-modal"].hide();
      this.checkboxInsConfirm = 'false'
    },
    closeModal() {
      this.checkboxInsConfirm = 'false'
      this.$emit("emitedInsConfirmation", this.checkboxInsConfirm);
      this.$refs["ins-conf-modal"].hide();
    },
    getTerritory() {
      return this.bookingInfo.booking_site === "com" ? "UK" : "IE";
    },
  }

}
</script>

<style>

</style>